/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaVnfSecuredConfiguration {
  rootUrl: string = '/web';
}

/**
 * Parameters for `ShivaVnfSecuredModule.forRoot()`
 */
export interface ShivaVnfSecuredConfigurationParams {
  rootUrl?: string;
}
